// 這是Webpack掛載起始點
import PackLayout from './pack_layout.vue'
import UnpackLayout from './unpack_layout.vue'

const router = [
    {
        path: '/packer/pack',
        component: PackLayout,
        name: 'pack'
    },
    {
        path: '/packer/unpack',
        component: UnpackLayout,
        name: 'unpack'
    },
]

export default router;
